import { css } from "@emotion/css";

import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createDialogButtonsWrapperStyles = ({ spacing }: Theme) => ({
  buttonsWrapper: css({
    display: "grid",
    gridAutoFlow: "column",
    justifyContent: "end",
    alignItems: "center",
    gap: spacing(1),
    minHeight: spacing(9),
    padding: spacing([2, 3]),
    backgroundColor: grey[0],
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
  }),
});
